export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-yen-fcbd7a6a6d71df15911a0c964de5c20f.svg";